export default __webpack_public_path__ + "static/media/hbs-bpk-poster-1.548554eb.jpg";